export default __webpack_public_path__ + "static/media/favicon.26bccd3b.ico";